import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el material después de comprar?',
    a: 'Recibes acceso inmediato por email en menos de 5 minutos. Todo en PDF descargable desde cualquier dispositivo.'
  }, {
    q: '¿Sirve para entrenadores particulares o solo para clubes?',
    a: 'Sirve para ambos. Club, academia, entrenamiento particular o escuela deportiva.'
  }, {
    q: '¿Es editable? ¿Puedo modificarlo?',
    a: 'El material es en PDF. Puedes imprimirlo y usarlo en pantalla. La edición directa no está habilitada.'
  }, {
    q: '¿Los 6 bonos están en las dos ofertas?',
    a: 'Sí. Los 6 bonos están incluidos en ambas opciones sin costo adicional.'
  }, {
    q: '¿Sirve si soy entrenador nuevo con poca experiencia?',
    a: 'Sí. Abres el tomo, lees 3 minutos y entras a la cancha con todo resuelto.'
  }, {
    q: '¿Sirve para jugadores de todas las edades?',
    a: 'Sí. Desde U10 hasta alto rendimiento adulto.'
  }, {
    q: '¿Qué pasa si tengo jugadores de distintos niveles?',
    a: 'Cada sesión incluye variantes para nivel más fácil y más difícil.'
  }, {
    q: '¿Qué diferencia tiene EDULABS con otros materiales?',
    a: 'Es el único sistema que cubre técnica, táctica, físico, planificación, evaluación y gestión en un solo lugar.'
  }, {
    q: '¿Por qué elegir el Combo con Kit Táctico Pro?',
    a: 'Porque el Kit resuelve el día del partido: el tiempo muerto, el marcador en contra y la dirección táctica clara.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días sin preguntas. El 100% de tu dinero de vuelta si no es lo que esperabas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 px-4 bg-dark-DEFAULT border-t border-dark-border" data-id="element-53">
      <div className="max-w-3xl mx-auto" data-id="element-54">
        <h2 className="text-4xl md:text-5xl font-bebas text-center mb-12" data-id="element-55">
          <span className="text-white" data-id="element-56">Preguntas </span>
          <span className="text-brand-DEFAULT" data-id="element-57">Frecuentes</span>
        </h2>

        <div className="space-y-4" data-id="element-58">
          {faqs.map((faq, index) => <div key={index} className="bg-dark-card border border-dark-border rounded-lg overflow-hidden" data-id="element-59">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-dark-border/50 transition-colors" data-id="element-60">
                <span className="font-medium text-brand-DEFAULT pr-4" data-id="element-61">
                  {faq.q}
                </span>
                <ChevronDownIcon size={20} className={`text-brand-DEFAULT transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-62" />
              </button>
              <AnimatePresence data-id="element-63">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-64">
                    <div className="px-6 pb-4 text-text-secondary text-sm leading-relaxed border-t border-dark-border pt-4" data-id="element-65">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}